function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import InfoIcon from "../Icon/Info";
import RcTooltip from 'rc-tooltip';
import PropTypes from 'prop-types';
export default class Tooltip extends React.Component {
  render() {
    const {
      placement,
      tooltip,
      delay,
      children,
      disabled,
      method = 'hover',
      wide,
      sherlock
    } = this.props;
    if (disabled) return /*#__PURE__*/React.createElement(React.Fragment, null, children);
    /**
     * @type {any}
     */

    let content = children || /*#__PURE__*/React.createElement("div", {
      className: "iconWrapper"
    }, /*#__PURE__*/React.createElement(InfoIcon, null));
    let overlayClassName = wide ? 'wideTooltipWrapper' : 'tooltipWrapper';

    if (sherlock) {
      overlayClassName = `${overlayClassName} sherlockTooltipWrapper`;
    }

    return /*#__PURE__*/React.createElement(RcTooltip, {
      placement: placement || 'top',
      trigger: [method],
      overlayClassName: overlayClassName,
      overlay: tooltip,
      mouseEnterDelay: delay || 0,
      mouseLeaveDelay: 0
    }, content);
  }

}

_defineProperty(Tooltip, "propTypes", {
  placement: PropTypes.string,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  method: PropTypes.string,
  delay: PropTypes.number,
  children: PropTypes.element,
  disabled: PropTypes.bool,
  wide: PropTypes.bool,
  sherlock: PropTypes.bool
});

_defineProperty(Tooltip, "defaultProps", {
  placement: 'top',
  delay: 0
});